// Sentinel values for the two meta-options at the top of the allowlist select.
// Neither is ever persisted: "All Detected" saves every concrete document type,
// and "Any Document Type" saves an empty list (i.e. the measure applies to all).
export const ALL_DETECTED_VALUE = '__all_detected__'
export const ANY_VALUE = '__any__'

// Canonical labels and descriptions for the two bulk options - single source
// for the chips, the menu items, and the read-only text so they never diverge.
// Exported so tests stay in sync with copy changes.
export const ALL_DETECTED_LABEL = 'All Registered Templates'
export const ANY_LABEL = 'All Templates'
export const ALL_DETECTED_DESCRIPTION =
  'When "Restrict Template Creation to Organization Admins" is enabled for the organization, only run compliance measures on already registered templates.'
export const ANY_DESCRIPTION =
  'Always runs this compliance measure regardless of template registration status in Clinically AI.'
